import { render, staticRenderFns } from "./ModalBarang.vue?vue&type=template&id=5b8f45ff&scoped=true&"
import script from "./ModalBarang.vue?vue&type=script&lang=js&"
export * from "./ModalBarang.vue?vue&type=script&lang=js&"
import style0 from "./ModalBarang.vue?vue&type=style&index=0&id=5b8f45ff&lang=scss&scoped=true&"
import style1 from "./ModalBarang.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f45ff",
  null
  
)

export default component.exports